import script from "./DownPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DownPage.vue?vue&type=script&setup=true&lang=js"

import "./DownPage.vue?vue&type=style&index=0&id=27f41ca3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f41ca3"]])

export default __exports__